import React, {useState, useEffect} from 'react'
import {useDispatch} from 'react-redux'
import useEntities from '../../../hooks/useEntities'
import useTitle from '../../../hooks/useTitle'
import Filters from './Filters'
import Table from './Table'
import withPagination from '../../withPagination'
import {setTitle} from '../../../actions'


const TablePaginated = withPagination(Filters, Table)

const TicketPriorities = () => {
  const dispatch = useDispatch()

  useTitle((title) => dispatch(setTitle(title)), 'Ticket - priorità')

  const {entities, total} = useEntities("ticket-priorities")
  const [shownEntities, setShownEntities] = useState([])

  useEffect(() => {
    setShownEntities(entities)
  }, [entities])

  return (
    <TablePaginated
      entities={entities}
      shownEntities={shownEntities}
      setShownEntities={setShownEntities}
      total={total}
      isLocal
    />
  )
}

export default TicketPriorities